import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import moment from 'moment';
import { NotificationTypeEnum } from '@/enums/NotificationTypeEnum';
import { batchUpdate } from '@/utils/batchUpdate';

const notificationsModule: Module<any, any> = {
  namespaced: false,
  state: {
    notifications: [],
    notificationsFamilyMember: [],
  },

  mutations: {
    setNotifications(state: any, payload: []) {
      state.notifications = payload;
    },
    setNotificationsFamilyMember(state: any, payload: []) {
      state.notificationsFamilyMember = payload;
    }
  },

  actions: {
    async readNotification({ commit }, { notificationsIds, readByUserId }) {
      const notifications = await this.dispatch("getWhereIdInIds", {
        ids: notificationsIds, path: 'notifications'
      })

      const itemsToUpdate = notifications.map(n => {
        const readByStaffs = n.readByStaffs || []
        readByStaffs.push({ id: readByUserId, dateTime: new Date() })
        const itemToUpdate = { docId: n.id, updates: { readByStaffs: readByStaffs } }
        return itemToUpdate
      })

      const result = await batchUpdate('notifications', itemsToUpdate)
      console.log('read notification result: ', result)
    },
    async getNotifications({ commit }, residentId) {

      const fromDate = moment()
        .subtract(1, "days")
        .toDate();
      const toDate = moment().toDate();

      let notifications = firebase
        .firestore()
        .collection("notifications")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("dateTimeCreated", ">=", fromDate)
        .where("dateTimeCreated", "<=", toDate)
        .where("to", "==", "resident")

      if (residentId && residentId.length > 0) {
        notifications = notifications.where("residentId", "==", residentId)
      }

      notifications = notifications.orderBy("dateTimeCreated", "desc");


      await notifications.get().then(querySnapshot => {
        let notificationsList: Array<any> = [];

        const docs = querySnapshot.docs
          .map(x => {
            const n = x.data();
            n.id = x.id;
            return n;
          })
          .filter(
            x => !(x.type == NotificationTypeEnum.Call && !x.isCallMissed)
          );

        docs.forEach(thisRes => {
          if (thisRes.eventStartTime) {
            if (thisRes.body.indexOf("<<eventStartTime>>") === -1) {
              //To support old messages. Will add date in the end of message.
              thisRes.body = `${thisRes.body} ${moment(
                thisRes.eventStartTime.seconds * 1000
              ).format("DD MMM, hh:mm A")}`;
            } else {
              //To replace date-key with a formatted date
              thisRes.body = thisRes.body.replace(
                "<<eventStartTime>>",
                moment(thisRes.eventStartTime.seconds * 1000).format(
                  "DD MMM, hh:mm A"
                )
              );
            }
          }

          if (
            thisRes.type === NotificationTypeEnum.Call &&
            thisRes.isCallMissed === true
          ) {
            thisRes.body = `You missed a ${thisRes.hasVideo ? "video" : ""
              } call from ${thisRes.fromName}`;
          }

          notificationsList.push(thisRes);
        });

        const getKey = notification =>
          `${notification.type}${moment(
            notification.dateTimeCreated.seconds * 1000
          ).format("MM.DD.YYYY")}${notification.residentId}`;

        let messages = notificationsList.reduce((total, current) => {
          if (current.type !== "message") return total;

          const key = getKey(current);

          if (total[key]) {
            total[key].count++;
          } else {
            total[key] = {
              count: 1,
              value: {
                ...current
              }
            };
          }

          return total;
        }, {});

        messages = Object.values(messages).map((message: any) => ({
          ...message.value,
          body: `${message.count} ${message.count > 1 ? "Chat Messages" : "Chat Message"
            }`
        }));

        const keys = messages.map(current => getKey(current));

        notificationsList = [
          ...notificationsList.filter(
            notification => !keys.includes(getKey(notification))
          ),
          ...messages
        ].sort((left, right) => {
          return moment(left.dateTimeCreated.seconds * 1000).diff(
            moment(right.dateTimeCreated.seconds * 1000)
          );
        });

        commit("setNotifications", notificationsList);
      });
    },
    async getNotificationsFamilyMember({ commit }, id) {

      const fromDate = moment().subtract(31, "days").toDate();
      const toDate = moment().toDate();

      return await firebase
        .firestore()
        .collection("notifications")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("dateTimeCreated", ">=", fromDate)
        .where("dateTimeCreated", "<=", toDate)
        .where("familyHubUserId", "==", id).get()
        .then(querySnapshot => {
        const resList: Array<any> = [];
        querySnapshot.docs.forEach(x => {
          const thisRes = x.data();
          resList.push(thisRes);
        });
        commit("setNotificationsFamilyMember", resList);
        return resList
      });
    }
  }
};
export default notificationsModule;
